module.exports = __webpack_public_path__ + "img/IMG-20210623-WA0000.90e18d6e.jpg";